import { Skeleton } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const DataTableFallback = ({
    title,
    buttonLabels,
}: {
    title: string;
    buttonLabels?: string[];
}) => {
    return (
        <HeaderFallback title={title} buttonLabels={buttonLabels}>
            <Skeleton variant="rectangular" height={150} />
        </HeaderFallback>
    );
};

export default DataTableFallback;
